<template>
    <c-icon :icon="icon" :size="size" class="flex-shrink-0" />
</template>

<script setup>
import CIcon from '@coreui/icons-vue';

const props = defineProps({
    icon: String,
    size: String,
});
</script>
